import React from "react";
import Modal from "@/components/Modal/Modal";
import Button from "@/components/Button/Button";
import styles from "./ConfirmLogoutModal.module.scss";
import DANGER from "@/assets/png/Danger.png";

interface ConfirmLogoutModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const ConfirmLogoutModal: React.FC<ConfirmLogoutModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
}) => {
  return (
    <Modal
      heading="Confirm Logout"
      modalOpen={isOpen}
      closeModal={onClose}
      className={styles.modal}
    >
      <img alt="" src={DANGER} className={styles.danger} />
      <h3>Log out</h3>
      <p>Are you sure you want to log out of your account?</p>
      <div className={styles.buttonContainer}>
        <Button className={styles.cancelButton} onClick={onClose}>
          Cancel
        </Button>
        <Button className={styles.logoutButton} onClick={onConfirm}>
          Logout
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmLogoutModal;
